import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  List,
  Stack,
  Money,
  ErrorListItem,
  ContentIsland,
  SectionedGridContainer,
  Box,
  Skeleton,
} from '@razz-team/ui-web';
import { useCallback, useMemo, useState } from 'react';
import { roundRobin } from '@razz-team/utils';
import { useAccountsSummary } from '../../../api/accounts';

export function HomeSummary() {
  const { t } = useTranslation();
  const summaryQuery = useAccountsSummary();
  const [currentBalanceIndex, setCurrentBalanceIndex] = useState(0);

  const balances = useMemo(() => {
    if (!summaryQuery.data) {
      return [];
    }
    const output = [
      {
        key: t('All accounts'),
        value: summaryQuery.data?.amountTotal,
      },
    ];
    Object.entries(summaryQuery.data.byType).forEach(([key, value]) => {
      if (value) {
        switch (key) {
          case 'FIAT':
            output.push({
              key: t(`Fiat`),
              value: value,
            });
            break;
          case 'CRYPTO':
            output.push({
              key: t(`Crypto`),
              value: value,
            });
            break;
          case 'CURRENT':
            output.push({
              key: t(`Current`),
              value: value,
            });
            break;
        }
      }
    });
    return output;
  }, [summaryQuery.data, t]);

  const switchBalance = useCallback(() => {
    setCurrentBalanceIndex((prev) => roundRobin(prev, balances.length - 1));
  }, [balances.length]);

  const balance = balances[currentBalanceIndex];

  return (
    <ContentIsland title={t(`Total balance`)}>
      <SectionedGridContainer direction="row" justifyContent="space-between">
        <Grid
          size={{
            md: 4,
          }}
        >
          {summaryQuery.isPending || summaryQuery.isSuccess ? (
            <Box width="100%">
              <Money variant="h2" loading={summaryQuery.isPending} value={balance?.value} />
              {summaryQuery.isPending ? (
                <Skeleton width={64} />
              ) : (
                <Button
                  variant="text"
                  color="info"
                  onClick={switchBalance}
                  fullWidth
                  sx={{ justifyContent: 'flex-start' }}
                >
                  {balance?.key}
                </Button>
              )}
            </Box>
          ) : summaryQuery.isError ? (
            <List>
              <ErrorListItem error={summaryQuery.error} />
            </List>
          ) : null}
        </Grid>
        <Grid
          display="flex"
          justifyContent="flex-end"
          size={{
            md: 8,
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Button href="/account/topup">{t(`Top up`)}</Button>
            <Button href="/account/exchange/start">{t(`Exchange`)}</Button>
            <Button href="/account/transfer/start">{t(`Transfer`)}</Button>
          </Stack>
        </Grid>
      </SectionedGridContainer>
    </ContentIsland>
  );
}
